import { useEffect, useState } from 'react';
import { fetchJsonCached } from '../lib/settingsCache';
import { resolveMediaUrl } from '../lib/mediaUrl';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Home page FEATURING widget.
 *
 * Managed from Admin -> Featuring Widget. There are always 4 slots; the public
 * endpoint returns only the slots that actually have an image, so the home page
 * hides the blanks and centres whatever is left (1-4 tiles).
 */
export const useFeaturedWidget = () => {
  const [state, setState] = useState({ heading: 'FEATURING', slots: [], loading: true });

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const data = await fetchJsonCached(`${API_URL}/api/settings/featured-widget`);
        if (cancelled) return;
        const slots = (data?.slots || [])
          .filter((s) => s && s.image_url)
          .map((s) => ({
            imageUrl: resolveMediaUrl(s.image_url),
            title: s.title || '',
            link: s.link || '',
          }));
        setState({ heading: data?.heading || 'FEATURING', slots, loading: false });
      } catch (error) {
        if (!cancelled) setState((prev) => ({ ...prev, loading: false }));
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
};

export default useFeaturedWidget;
